import * as core from '../../../../../../../core'
import * as orgJointUseCalcMode from '../org-joint-use-calculation-mode'

export const RESOURCE = {
  payload: {
    description: 'Salary',
    enumId: core.dms.models.Enum.Id.from({
      partialId: orgJointUseCalcMode.RESOURCE.payload.partialId,
    }),
    id: 'SALARY',
    name: 'Salary',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
